import { buildScopedI18n } from '../../utils/buildScopedI18n';
import dsuEsCL from './locales/es-CL.json';
import dsuEnUS from './locales/en-US.json';
import dsuPtBR from './locales/pt-BR.json';

export const dailyStateUnholsterI18n = buildScopedI18n({
  esCL: dsuEsCL,
  enUS: dsuEnUS,
  ptBR: dsuPtBR,
});
